import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { colors, topHeroContainerHeight } from "../../../styles/variables";

import { Container } from "../../atoms/Container";

/* Coral page hero used by WineList, Wines, ProductCollections,
 * SpecialPacks, QuizResults, InStoreQuizResults. Safe-area-top
 * handling lives in Layout's <main> on Capacitor — no need for a
 * per-hero padding here. */
const StyledHero = styled.div`
  background-color: ${colors.coral};
`;

const StyledHeroContainer = styled(Container)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
  height: ${topHeroContainerHeight}px;
`;

export const HeroTitle = styled.h1`
  font-size: 50px;
  text-transform: uppercase;
`;

export const HeroPicture = styled.img`
  max-width: 100%;
`;

export const Hero = ({ children }) => (
  <StyledHero>
    <StyledHeroContainer>{children}</StyledHeroContainer>
  </StyledHero>
);

Hero.propTypes = {
  children: PropTypes.node.isRequired,
};
